module.exports = "<p>\n  outgoing-actions works!\n</p>\n"